import { render } from "./ConfirmPage.vue?vue&type=template&id=3cd0be09&scoped=true"
import script from "./ConfirmPage.vue?vue&type=script&lang=js"
export * from "./ConfirmPage.vue?vue&type=script&lang=js"

import "./ConfirmPage.vue?vue&type=style&index=0&id=3cd0be09&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd0be09"]])

export default __exports__